import { Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useModal, usePage, useResource, useToast } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { APIS, SF_COMN_CD_MGMT_MSTR_INFO, URLS } from "./services/PtliComnCdAppService";
import { useEffect } from "react";

/*
 * Common Code Registration
 * !== 공통 코드 등록 ==!
 */
export const PTLI0404002S = (props: any) => {
    const {} = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0061", "auth_ecti0001", "auth_ecti0009"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const [params] = useSearchParams();
    const bsopClsfCd = params.get("bsopClsfCd");

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "COM0024" }],
    });

    const form = {
        comnCdMgmtMstrInfo: useForm({
            defaultSchema: SF_COMN_CD_MGMT_MSTR_INFO,
        }),
    };

    const fetch = {
        // Common Code Duplicate Check !== 공통 코드 중복 체크 ==!
        getComnCdMstrInfo: useFetch({
            api: (data: any) => APIS.getComnCdMstrInfo(data),
            enabled: false,
            onSuccess: (data) => {
                if (data.comnCdMstr.content) {
                    form.comnCdMgmtMstrInfo.setError("comnCd", {
                        message: "msg.ptl.00678", // The same common codes exist. !== 동일한 공통 코드가 존재합니다. ==!
                        type: "error",
                    });
                } else {
                    form.comnCdMgmtMstrInfo.clearErrors("comnCd");
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Save Common Code !== 공통 코드 저장 ==!
        saveComnCdMstr: useFetch({
            api: (data: any) => APIS.saveComnCdMstr(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({ content: "msg.com.00058" }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                navigate(URLS.ptli0404003q + "/" + form.comnCdMgmtMstrInfo.getValue("comnCd"));
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
    };

    const handler = {
        // Common Code Duplicate Check !== 공통 코드 중복 체크 ==!
        getComnCdMstrInfo: () => {
            const comnCd = form.comnCdMgmtMstrInfo.getValue("comnCd");
            if (comnCd) {
                fetch.getComnCdMstrInfo.fetch(comnCd);
            } else {
                form.comnCdMgmtMstrInfo.clearErrors("comnCd");
            }
        },
        // Save Common Code !== 공통 코드 저장 ==!
        saveComnCdMstr: () => {
            if (!comnUtils.isEmpty(form.comnCdMgmtMstrInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.comnCdMgmtMstrInfo.handleSubmit(
                () => {
                    const data = form.comnCdMgmtMstrInfo.getValues();
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveComnCdMstr.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    useEffect(() => {
        if (bsopClsfCd) {
            form.comnCdMgmtMstrInfo.setValue("bsopClsfCd", bsopClsfCd);
            form.comnCdMgmtMstrInfo.setSchema("bsopClsfCd", { readOnly: true, disabled: true });
        }
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.comnCdMgmtMstrInfo.schema.comnCd}
                                onBlur={() => {
                                    handler.getComnCdMstrInfo();
                                }}
                            />
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.bsopClsfCd} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmEn} />
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmTz} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdNmKo} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtMstrInfo.schema.comnCdDataLenVal} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button
                        role={"list"}
                        onClick={() => {
                            if (bsopClsfCd) {
                                navigate(`${URLS.ptli0404001q}?bsopClsfCd=${bsopClsfCd}`);
                            } else {
                                navigate(URLS.ptli0404001q);
                            }
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.saveComnCdMstr} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
